import { render, staticRenderFns } from "./UpdateAccountInfo.vue?vue&type=template&id=35ad3313&scoped=true&"
import script from "./UpdateAccountInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateAccountInfo.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAccountInfo.vue?vue&type=style&index=0&id=35ad3313&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ad3313",
  null
  
)

export default component.exports